// vue-esign 插件
// 迁移自 main.js 中的电子签名组件注册

import Vue from 'vue'
import vueEsign from 'vue-esign'

Vue.use(vueEsign)
